import { useEffect } from "react";
import { CallData } from "../../../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setActiveCallUser } from "../../../../../ReduxToolkit/Reducers/Messenger/Chat";
import { AllCallType } from "../../../../../Types/MessengerType";
import { dynamicImage, Image } from "../../../../../Utils";

const AllCall: React.FC<AllCallType> = ({ startValue, endValue }) => {
  const dispatch = useAppDispatch();
  const { activeCallUser } = useAppSelector((state) => state.chat);
  useEffect(() => {dispatch(setActiveCallUser({ userName: "Jony Lynetin", userId: 1, userImage: "2" }))}, [dispatch]);
  
  return (
    <ul className="call-log-main custom-scroll">
      {CallData.slice(startValue, endValue).map((item, index) => (
        <li className={activeCallUser?.userId === item.id ? "active" : ""} key={index} onClick={() => dispatch(setActiveCallUser({ userName: item.name, userId: item.id, userImage: item.avatar }))}>
          <div className="call-box">
            <div className={`profile ${item.onlineStatus}`}>
              <Image className="bg-img img-fluid" src={dynamicImage(`contact/${item.avatar}.jpg`)} alt="Avatar" />
            </div>
            <div className="details">
              <h4>{item.name}</h4>
              <h5>{item.icon}{item.time}</h5>
            </div>
            <div className="call-status">
              <div className={`icon-btn btn-outline-${item.color} button-effect btn-sm`}>{item.callStatusIcon}</div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default AllCall;
